import { userStore } from '@/store';

/**
 * 检查用户是否已登录并绑定手机号。
 * 未登录时触发登录弹窗，已登录但未绑定手机时触发绑定弹窗（传入 type 可跳过手机绑定检查）。
 * @returns true 表示未通过检查，调用方应中断后续操作；false 表示检查通过
 */
export const checkLogin = (type?: string) => {
  const { setTriggerLogin, userInfo, setMobileLogin } = userStore.getState();
  if (!userInfo?.token) {
    console.log("checkLogin setTriggerLogin", userInfo)
    setTriggerLogin();
    return true;
  } else if (!userInfo.actualUserInfo?.mobile && !type) {
    console.log("checkLogin setMobileLogin, userInfo.actualUserInfo, type", userInfo.actualUserInfo, type)
    setMobileLogin();
    return true;
  }
  return false;
};

/** 版本权限位掩码：基础版（type === 1） */
export const BASIC_FEATURE = 0b001;
/** 版本权限位掩码：正式版（type === 2 且 enterpriseAuthType === 1） */
export const OFFICIAL_FEATURE = 0b010;
/** 版本权限位掩码：尊享版（type === 2 且 enterpriseAuthType === 2） */
export const PREMIUM_FEATURE = 0b100;
/** 版本权限位掩码：企业版（正式版 | 尊享版，即 type === 2 的所有子类型） */
export const ENTERPRISE_FEATURE = OFFICIAL_FEATURE | PREMIUM_FEATURE;

/**
 * 检查当前用户是否拥有指定功能权限。
 * 通过位与运算匹配 feature 掩码，结合 userInfo.type 和 enterpriseAuthType 判断。
 * @param feature 权限掩码，可组合多个（如 BASIC_FEATURE | OFFICIAL_FEATURE）
 */
export const hasFeature = (feature: number) => {
  const { userInfo } = userStore.getState();
  const { type, enterpriseAuthType } = userInfo;

  return (
    (feature & BASIC_FEATURE && type === 1) ||
    (feature & OFFICIAL_FEATURE && type === 2 && enterpriseAuthType === 1) ||
    (feature & PREMIUM_FEATURE && type === 2 && enterpriseAuthType === 2)
  );
};
